<template>
  <mb-modal
    title="提示"
    :show.sync="show"
    confirmBtnText="继续考试"
  >
    <div slot="content">
     <p>监测到切屏</p>
    </div>
  </mb-modal>
</template>

<script>
import MbModal from '@/components/MbModal'
import { post } from '@/utils/ajax'
export default {
  components: {
    MbModal
  },
  props: {
    noRecordPageHidden: {
      type: Boolean
    },
    currentQuestion: {
      type: Object
    },
    testInfo: {
      type: Object
    }
  },
  mounted() {
    window.onblur = () => {
      if (document.activeElement.nodeName === 'IFRAME') {
      } else {
        const isNewTypeQuestion = this.currentQuestion.questionType === 1 && this.currentQuestion.typeId === 10
        if (!this.noRecordPageHidden && !isNewTypeQuestion) {
          this.pageHiddenEvent()
        }
      }
    }
  },
  data() {
    return {
      show: false,
      pageHiddenCount: 0
    }
  },
  destroyed() {
    window.onblur = null
  },
  methods: {
    // window.onblur，页面离开的逻辑
    pageHiddenEvent () {
      // this.pageHiddenCount++
      this.show = true
      this.commitAntiCheating()
    },
    // 上报离开页面的次数
    async commitAntiCheating () {
      const params = {
        admission_ticket: this.testInfo.admission_ticket,
        attach: {
          switch_mark: 1
        },
        name: this.testInfo.name,
        type: 3,
        account: this.testInfo.account,
        exam_id: localStorage.examId
      }
      try {
        await post('/home/abnormal', params)
      } catch (e) {
        console.error('上报失败')
      }
    }
    // 获取切屏上报的数量
    // async getPageHiddenCount () {
    //   try {
    //     const data = await get('/home/abnormal/times', {
    //       userId: this.user.id,
    //       examId: localStorage.examId,
    //       type: 3
    //     })
    //     this.pageHiddenCount = data
    //   } catch (e) {
    //     console.log(e)
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
  .page-hidden-tip {
    /deep/ .modal-head {
      padding: 10px 20px;
      border-bottom: 1px solid #F1F1F1;
      .close-icon {
        top: 12px;
      }
    }
    .btn-wrap {
      justify-content: center;
      .continue {
        margin: 0;
      }
    }
    .tip-content {
      // padding-top: 20px;
      margin-bottom: 25px;
      .tip-title {
        font-size: 16px;
        line-height: 28px;
        color: #333;
        text-align: center;
        span {
          display: inline-block;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          background-color: rgba(255, 0, 0, .1);
          color: #FF0000;
          margin: 0 5px;
        }
      }
      .warning {
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        text-align: left;
        font-weight: 300;
      }
    }
  }
</style>
